<template>
  <div class="banner_container">
    <div class="text">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'JsBanner',
  props: {
    imgUrl: {
      type: String,
      default: '/img/about/banner3.png'
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.banner_container {
  width: 100%;
  height: 130px;
  background-image: url('/img/about/banner3.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .img {
    width: 100%;
  }
  .text {
    margin-right: 200px;
    color: #00439a;
    font-size: 32px;
  }
}
</style>
